import React from 'react';
import PropTypes from 'prop-types';

import { bibContextShape } from 'app/shapes/analytics';
import { ANALYTICS_CONTEXTS } from 'app/constants/AnalyticsConstants';

// contextName is deliberately not validated at runtime. propTypes constrain it on both this
// component and AnalyticsContextContainer; BibPageContainer is the only call site and passes the
// ANALYTICS_CONTEXTS.BIB constant. A guard here used to throw instead, which took down the whole
// page render to protect an analytics side effect. CORE-76971.
export default class AnalyticsContext extends React.PureComponent {
  constructor(props) {
    super(props);
    const { analyticsActions, context, contextName } = props;

    analyticsActions.setContext(contextName, context);
  }

  componentDidUpdate() {
    const { context, contextName, analyticsActions } = this.props;
    analyticsActions.setContext(contextName, context);
  }

  componentWillUnmount() {
    const { contextName, analyticsActions } = this.props;
    analyticsActions.setContext(contextName, undefined);
  }

  render() {
    return null;
  }
}

AnalyticsContext.propTypes = {
  analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  context: bibContextShape.isRequired,
  contextName: PropTypes.oneOf(Object.values(ANALYTICS_CONTEXTS)).isRequired
};
